import createTableStore from "ds/components/Table/store/useTableStore";

import { MIGRATION_QUEUE_TABLE_STORAGE_KEY } from "../constants";
import { MIGRATION_QUEUE_TABLE_COLUMNS_CONFIG } from "./constants";

const useOpenTofuMigrationQueueTableStore = createTableStore({
  storageKey: MIGRATION_QUEUE_TABLE_STORAGE_KEY,
  config: MIGRATION_QUEUE_TABLE_COLUMNS_CONFIG,
});

export default useOpenTofuMigrationQueueTableStore;
